import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ChildOnboardingModal from '../components/ChildOnboardingModal';
import PrivacyConsentModal from '../components/PrivacyConsentModal';

/**
 * Layout wrapper for end-user routes.
 * Shows privacy consent modal first, then onboarding modal if needed.
 */
const EndUserLayout: React.FC = () => {
  const { user, needsOnboarding, refetchUser, logout } = useAuth();

  // Check if user needs to accept privacy policy
  const needsPrivacyConsent = user && !user.privacyPolicyAccepted;

  const handlePrivacyAccepted = () => {
    refetchUser();
  };

  const handlePrivacyDeclined = () => {
    logout();
  };

  return (
    <>
      <Outlet />
      
      {/* Privacy consent modal - show first before onboarding */}
      {needsPrivacyConsent && (
        <PrivacyConsentModal
          onAccept={handlePrivacyAccepted}
          onDecline={handlePrivacyDeclined}
        />
      )}
      
      {/* Onboarding modal - only show after privacy is accepted */}
      {!needsPrivacyConsent && needsOnboarding && (
        <ChildOnboardingModal onComplete={refetchUser} />
      )}
    </>
  );
};

export default EndUserLayout;
